module.exports = __webpack_public_path__ + "static/img/sysShow4.c1acb59b.png";